import React from 'react'
import { connect } from 'react-redux'

import { getLoading } from '../../state/reducers/loading'

const Loading = ({ loading }) => {
  // Validation des props et gestion des cas limites
  if (!loading || !Array.isArray(loading) || loading.length === 0) {
    return null
  }

  return (
    <div
      className="loading"
      role="status"
      aria-live="polite"
      aria-label="Indicateur de chargement"
      aria-describedby="loading-description"
    >
      {/* Description cachée pour les lecteurs d'écran */}
      <span id="loading-description" className="visually-hidden">
        {loading.length === 1 
          ? 'Un élément est en cours de chargement'
          : `${loading.length} éléments sont en cours de chargement`
        }
      </span>
      
      {/* Indicateur visuel de chargement */}
      <div className="loading-spinner" aria-hidden="true">
        <div className="spinner" />
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  loading: getLoading(state)
})

export default connect(mapStateToProps)(Loading)
